import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import NavigationMenu from '../NavigationMenu/navigationMenu';  // Importa el NavigationMenu

const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

interface DrawerComponentProps {
  open: boolean;
  handleDrawerClose: () => void;
}

const DrawerComponent: React.FC<DrawerComponentProps> = ({ open, handleDrawerClose }) => {
  const theme = useTheme();
  const user = React.useMemo(() => {
    const encodedUser = localStorage.getItem('user');
    if (!encodedUser) return 'Usuario EMCALI';
    try {
      return atob(encodedUser);
    } catch {
      return 'Usuario EMCALI';
    }
  }, []);

  return (
    <MuiDrawer
      variant="temporary"
      open={open}
      onClose={handleDrawerClose}
      ModalProps={{ keepMounted: true }}
      sx={{
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#f8fafc',
          borderRight: 'none',
          boxShadow: '0 16px 40px rgba(15, 23, 42, 0.25)',
          borderTopRightRadius: 14,
          borderBottomRightRadius: 14,
          mt: '100px',
          height: 'calc(100% - 118px)',
        },
      }}
    >
      <DrawerHeader>
        <IconButton onClick={handleDrawerClose} sx={{ color: '#334155' }}>
          {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </DrawerHeader>
      <Divider />
      {/* Renderiza el menú de navegación */}
      <NavigationMenu open={open} />
      <Stack
        direction="row"
        sx={{
          px: 1.5,
          py: 1.5,
          gap: 1,
          alignItems: 'center',
          borderTop: '1px solid #e5e7eb',
          mt: 'auto',
        }}
      >
        <Avatar sx={{ width: 34, height: 34, bgcolor: '#1e3a8a', fontSize: 14 }}>
          {user?.[0]?.toUpperCase() || 'U'}
        </Avatar>
        {open && (
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: '#0f172a' }} noWrap>
              {user}
            </Typography>
            <Typography variant="caption" sx={{ color: '#64748b' }}>
              Proyectos
            </Typography>
          </Box>
        )}
      </Stack>
    </MuiDrawer>
  );
};

export default DrawerComponent;
